import { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import api from "@/lib/api";
import { MASK } from "@/lib/privacy";

/** Montant masqué « •••••• » (droit absent ou œil fermé). */
export const MaskedAmount = ({ color = "#8b8b93", size = 17, testId }) => <span className="tabular-nums" style={{ fontSize: size, fontWeight: 700, color, letterSpacing: 2 }} data-testid={testId} data-masked="true">{MASK}</span>;

/** Œil 16 px : masque / affiche les totaux financiers ; préférence mémorisée côté serveur (user_prefs.hide_financial_totals). */
export function useHideTotals() {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("ledesk:hide_totals") === "1");
  useEffect(() => { api.get("/me/prefs").then(({ data }) => { setHidden(!!data.hide_financial_totals); sessionStorage.setItem("ledesk:hide_totals", data.hide_financial_totals ? "1" : "0"); }).catch(() => {}); }, []);
  const toggle = async () => { const next = !hidden; setHidden(next); sessionStorage.setItem("ledesk:hide_totals", next ? "1" : "0"); try { await api.patch("/me/prefs", { hide_financial_totals: next }); } catch { /* préférence locale conservée */ } };
  return [hidden, toggle];
}

export function EyeToggle({ hidden, onToggle, testId = "totals-eye" }) {
  const Icon = hidden ? EyeOff : Eye;
  return <button type="button" onClick={onToggle} title={hidden ? "Afficher les totaux" : "Masquer les totaux"} aria-pressed={hidden} className="inline-flex items-center justify-center" style={{ width: 26, height: 26, borderRadius: 7, color: hidden ? "#E0A42E" : "#8b8b93", background: "transparent", border: "0.5px solid #2e2e34" }} data-testid={testId}><Icon size={16} /></button>;
}
